import POST_COMPONENT_TYPE from '../postComponentType';
import ElevatedBloodSugarAndDiabetesHero from '../../../assets/images/elevated-blood-sugar-and-diabetes-hero-section.png';
import { IconType } from '../../../components/BannerWithList';
import { TextBoxBackgroundColor } from '../../../components/BannerWithTextBox';

const elevatedBloodSugarAndDiabetesData = {
  key: 'elevated-blood-sugar-and-diabetes',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.elevated-blood-sugar-and-diabetes.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: ElevatedBloodSugarAndDiabetesHero,
      text: 'learnMoreContent.elevated-blood-sugar-and-diabetes.banner.text',
      backgroundColor: TextBoxBackgroundColor.RED
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title:
        'learnMoreContent.elevated-blood-sugar-and-diabetes.elevated-blood-sugar.title',
      iconType: IconType.WARNING,
      listGroups: [
        {
          items: [
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.elevated-blood-sugar.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.elevated-blood-sugar.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.elevated-blood-sugar.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title:
        'learnMoreContent.elevated-blood-sugar-and-diabetes.overweight.title',
      iconType: IconType.WARNING,
      listGroups: [
        {
          items: [
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.overweight.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.overweight.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.overweight.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title:
        'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.title',

      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title:
            'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem1',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem1.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem1.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem1.subItem3',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem1.subItem4',
                  type: 'text'
                }
              ]
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem2',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem2.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem2.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem2.subItem3',
                  type: 'text'
                }
              ]
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.measured.listGroup1.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title:
        'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.title',

      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title:
            'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem2',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem2.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem2.subItem2',
                  type: 'text'
                }
              ]
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem4',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.elevated-blood-sugar-and-diabetes.improvement.listGroup1.listItem5',
              type: 'text'
            }
          ]
        }
      ]
    }
  ]
};

export default elevatedBloodSugarAndDiabetesData;